import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  noItems: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    margin: '69px 0',
  },
  noItemsContent: {
    width: 600,
    border: '1px solid red',
    textAlign: 'center',
    borderRadius: 5,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    }
  }
}))

export default function ContentNotLoaded(props){
  const classes = useStyles()

  return (
    <div className={classes.noItems}>
      <Grid className={classes.noItemsContent}>
        <p>{props.message}</p>
      </Grid>
    </div>
  )
}